import { get, post, put } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface DigestSettings {
  /** Whether the digest posts every morning at 07:00 */
  enabled: boolean;
  source: "admin" | "environment" | null;
  /** The webhook with its secret part hidden */
  webhookHint: string | null;
  updatedBy: string | null;
  updatedAt: string | null;
}

/** A Slack message: header and mrkdwn sections */
export interface DigestMessage {
  text: string;
  blocks: { type: string; text: { type: string; text: string } }[];
}

/** Staff: the daily Slack digest */
export const getDigestSettings = (): Promise<ApiResponse<DigestSettings>> => get(`/admin/digest/settings`, null);

export const setDigestWebhook = (slackWebhookUrl: string | null): Promise<ApiResponse<DigestSettings>> =>
  put(`/admin/digest/settings`, { slackWebhookUrl });

export const previewDigest = (): Promise<ApiResponse<DigestMessage>> => get(`/admin/digest`, null);

export const sendDigest = (): Promise<ApiResponse<DigestMessage>> => post(`/admin/digest/send`);
